import { useEffect, useMemo, useState } from 'react';

import { getColumnsAdvancedFilters } from '@commons/utils/filtersFetches';

const FILTERABLE_TYPES = ['string', 'text'];

export const useRoleModalFilters = (data, columns) => {
  const [filters, setFilters] = useState(null);
  const [applyFilters, setApplyFilters] = useState(true);
  const [advancedFilters, setAdvancedFilters] = useState(null);
  const [filteredData, setFilteredData] = useState(data);

  const filterableColumns = useMemo(
    () => columns.filter(({ filterType }) => FILTERABLE_TYPES.includes(filterType)),
    [columns],
  );

  const columnsFilterList = useMemo(
    () => getColumnsAdvancedFilters(filterableColumns, data),
    [filterableColumns, data],
  );

  useEffect(() => {
    setFilteredData(data);
  }, [data]);

  useEffect(() => {
    if (!applyFilters) {
      return;
    }

    if (!advancedFilters?.length) {
      setFilteredData(data);
      return;
    }

    const result = advancedFilters.reduce(
      (acc, { doFilter, list, filterType, propertyKey, value }) => {
        if (filterType === 'string' && value?.length === 1 && value[0].id === 'none') {
          return doFilter(acc, propertyKey, list, true);
        }

        return doFilter(acc, propertyKey, value);
      },
      data,
    );

    setFilteredData(result);
  }, [applyFilters, advancedFilters, data]);

  return {
    filters,
    setFilters,
    applyFilters,
    setApplyFilters,
    advancedFilters,
    setAdvancedFilters,
    filteredData,
    columnsFilterList,
  };
};

export default { useRoleModalFilters };
